import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const paymentsApi = createApi({
  reducerPath: 'paymentsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Payments'],
  endpoints: (builder) => ({
    delete: builder.mutation({
      query: ({ id }) => ({ url: `payments/${id}`, method: 'DELETE' }),
      invalidatesTags: (results, error, { id }) => {
        return [{ type: 'Payments', id }]
      },
    }),
  }),
})

export const { useDeleteMutation } = paymentsApi

export default paymentsApi
